import { TranslationFile } from 'i18n';
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code'

interface QRCodeBlockProps {
	readonly qrCodeData: string
}

function QRCodeBlock({ qrCodeData }: QRCodeBlockProps) {
	const [isFullscreen, setIsFullscreen] = useState(false);
	
	const handleFullscreenChange = useCallback(() => {
		setIsFullscreen(Boolean(document.fullscreenElement));
	}, []);

	const { t } = useTranslation([TranslationFile.Translation])


	useEffect(() => {
		document.addEventListener('fullscreenchange', handleFullscreenChange);
		return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
	}, [handleFullscreenChange]);


	const toggleFullscreen = () => {
		if (isFullscreen) {
			document.exitFullscreen();
		} else {
			document.getElementById('qrCodeContainer')!.requestFullscreen()
		}
	};


	return (
		<div id='qrCodeContainer' onClick= {toggleFullscreen} aria-label={t('WCAG-Label-QRCode')} role="contentinfo" style={{ background: 'white', padding: '16px', cursor: 'pointer' }}>
			<QRCode 
				value={qrCodeData}
				size={256}
				style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
				viewBox={`0 0 256 256`}
			/>
		</div>
	)
}

export default QRCodeBlock
